import { isNullOrUndefined } from '@acceligentllc/shared/utils/extensions';

export class NotificationTimeSettingsFM {
	timezone: string;
	notificationTime: string;
	notificationDays?: { id: number; label: string; }[];

	static validate(form: NotificationTimeSettingsFM) {
		const errors: ValidationErrors = {};

		if (isNullOrUndefined(form.timezone)) {
			errors.timezome = 'Timezone must be defined';
		}

		if (isNullOrUndefined(form.notificationTime)) {
			errors.notifyTime = 'Notify time must be defined';
		}

		return errors;
	}
}
